export default __webpack_public_path__ + "static/media/img1011.4622753a.png";